import React from 'react';

const Graph_Canvas = () => {
    return (
        <div>Graph_Canvas Component</div>
    );
}

export default Graph_Canvas;
